<template>
    <div class="classic-website">
      <!-- 第四区域：页脚 -->
      <footer class="footer-section">
        <div class="container">
          <div class="footer-info" v-show="!isMobile">
            <p>Copyright◎北京蝠池文化传媒有限公司 <a href="https://beian.miit.gov.cn/" style="color: inherit; text-decoration: none;" target="_blank">京ICP备18058304号-1</a></p>
            <p>联系电话：13601121024　企业邮箱：chp1960@163.com　公司传真：010-64688015</p>
            <p>门店地址：北京市朝阳区左家庄15号院4号楼8107室</p>
          </div>

          <div class="footer-pinfo" v-show="isMobile">
            <p>Copyright◎北京蝠池文化传媒有限公司</p>
            <p>联系电话：13601121024　<a href="https://beian.miit.gov.cn/" style="color: inherit; text-decoration: none;" target="_blank">京ICP备18058304号-1</a></p>
            <p>门店地址：北京市朝阳区左家庄15号院4号楼8107室</p>
          </div>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ClassicBookWebsite',
    data() {
      return {
        isMobile: false,
      }
    },
    mounted() {
      this.checkScreenWidth()
    },
    beforeDestroy() {
      
    },
    methods: {
      // 判断是否为移动手机端
      checkScreenWidth() {
        this.isMobile = window.innerWidth <= 768
      },
      
    }
  }
  </script>
  
  <style scoped>
  /* 引入外部字体和图标库 20260105*/
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
  @import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Noto+Serif+SC:wght@400;600;700&display=swap');

  /* 导入原有的所有CSS样式 */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: 'Noto Serif SC', serif;
    line-height: 1.6;
    color: #5c3a21;
    background-color: #f5f0e6;
    background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C8B7E' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E");
    min-height: 100vh;
    overflow-x: hidden;
  }
  
  .container {
    width: 100%;
    /* max-width: 1200px; 20260107，增加界面的宽度*/
    max-width: 1500px;
    margin: 0 auto;
    padding: 0 15px;
  }
  
  .classic-border {
    border: 1px solid #c9b18b;
    border-radius: 3px;
    box-shadow: 0 4px 8px rgba(92, 58, 33, 0.1);
  }
  
  .classic-bg {
    background-color: #fffaf0;
    border: 1px solid #d4c4a8;
  }
  
  /* 第四区域：页脚 */
  .footer-section {
    background-color: #5c3a21;
    color: #e6d3b3;
    padding: 25px 0;
    border-top: 3px solid #8b4513;
  }
  
  .footer-info {
    text-align: center;
    line-height: 1.8;
  }
  
  .footer-info p {
    margin-bottom: 8px;
    font-size: 0.95rem;
    font-family: 'Noto Serif SC', serif;
  }

  /* 移动手机上的文字设置 */
  .footer-pinfo {
    text-align: center;
    line-height: 1.8;
  }
  .footer-pinfo p {
    margin-bottom: 8px;
    font-size: 0.85rem;
    font-family: 'Noto Serif SC', serif;
  }
  
  /* 响应式设计 */
  @media (max-width: 992px) {
    .main-container {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
  }
  
  @media (max-width: 768px) {
    .header-container {
      flex-direction: column;
      align-items: flex-start;
    }
    
  }
  
  @media (max-width: 576px) {
    .site-name h1 {
      font-size: 1.3rem;
    }

  }
  
  @media (max-width: 400px) {
    /* 超小屏幕仍然保持每行2本书 */
    .books-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
    
    .book-title {
      font-size: 0.8rem;
    }
    
  }
  </style>


// WEBPACK FOOTER //
// src/views/abottom/index.vue